import { useQuery } from "@tanstack/react-query";
import { useEffect, useMemo, useState } from "react";
import { useParams, useSearchParams } from "react-router";
import { gear } from "../../api/client";
import { ensurePaletteStyles } from "../../lib/categories";
import { GearListView, type GridLine } from "../library/components/GearListView";
import { useBodyClass } from "../login/useBodyClass";
import "../../styles/legacy/LibraryView.css";

/** `/list/:uuid` and the legacy `/list?id=N`: a read-only list for anyone with the link. */
export function SharedListPage() {
  useBodyClass("library-page");
  const params = useParams();
  const [search] = useSearchParams();
  const legacyId = search.get("id");
  const id = params.id ?? null;
  const q = useQuery({
    queryKey: ["public-list", id, legacyId],
    queryFn: () => (id ? gear.publicList(id) : gear.publicListByLegacy(Number(legacyId))),
    enabled: !!id || !!legacyId,
  });
  const [unitId, setUnitId] = useState<number | null>(null);
  useEffect(ensurePaletteStyles, []);
  const lines: GridLine[] = useMemo(() => {
    if (!q.data) return [];
    const byId = new Map(q.data.items.map((i) => [i.id, i]));
    return q.data.lines.flatMap((line) => {
      const item = byId.get(line.item_id);
      return item ? [{ key: line.id, item, line, quantity: line.quantity, worn: line.worn, consumable: line.consumable, checked: line.checked }] : [];
    });
  }, [q.data]);

  if (q.isLoading) return null;
  if (q.isError || !q.data) {
    return (
      <div style={{ padding: 40, fontFamily: "Verdana, Geneva, sans-serif", textAlign: "center" }}>
        <img src="/assets/ui/gg_logo.png" alt="GearGrams" style={{ width: 205, filter: "invert(60%)" }} />
        <p style={{ marginTop: 20 }}>That list does not exist or was deleted.</p>
        <p>
          <a href="/">Go to GearGrams</a>
        </p>
      </div>
    );
  }
  const title = q.data.owner_name ? `${q.data.list.name} — ${q.data.owner_name}` : q.data.list.name;
  return (
    <div className="SharedListView" style={{ position: "absolute", inset: 0 }}>
      <GearListView title={title} mode="readonly" lines={lines} libraryItems={[]} unitId={unitId ?? q.data.owner_unit_id} onUnitChange={setUnitId} actions={null} />
    </div>
  );
}
